import { useEffect, useRef, useState } from "react";
import keyImg from "../../../../../picture/info-key-img.png";
import lockedImg from "../../../../../picture/padlock-locked.png";
import unlockedImg from "../../../../../picture/padlock-unlocked.png";

const allValues = [
  {
    value: true,
    icon: lockedImg
  },
  {
    value: false,
    icon: unlockedImg
  }
];

const style = {
  divImage: {
    position: "relative",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    cursor: "pointer"
  }
};

const CustomSelectKey = ({ selectedValue, onSelectChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);
  const [stylesUp, setStylesUp] = useState({});

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    if (onSelectChange) onSelectChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";

    const stUp = {
      left: rect.left,
      width: rect.width,
      bottom: window.innerHeight - rect.top
    };
    setStylesUp(stUp);

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef}>
      <div onClick={handleOpen} style={style.divImage}>
        <img
          src={
            selectedValue === ""
              ? keyImg
              : selectedValue
                ? lockedImg
                : unlockedImg
          }
          style={{ width: "25px" }}
        />
      </div>
      <div
        ref={optionsRef}
        style={{
          ...stylesUp,
          position: "fixed",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          maxHeight: "300px",
          overflowY: "auto",
          width: "100%"
        }}
      >
        {allValues.map(({ value, icon }, index) => (
          <div
            key={index}
            onClick={() => handleSelect(value)}
            style={{
              ...style.divImage,
              backgroundColor: value === selectedValue ? "lightgrey" : "white"
            }}
          >
            <img src={icon} style={{ width: "20px" }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSelectKey;
